<template>
<div class="chapter">
<div class="inner_page">
<p class="space-break2"><a id="page5"></a><a id="page6">The epigraphs are all by Robert Browning, except one, which is a palpable forgery.</a></p><a id="page6">
<p class="space-break">This is not an autobiographical novel: it is about some <em>other</em> portly, dissolute, immoral and middle-aged art dealer. The rest of the characters are quite imaginary too, especially that Mrs. Spon, but most of the places are real.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?5ccb37a6